<template>
	<section>
		<header-page
			actions
			name="account-modules"
			:title="title"
			@run-action="runAction"
		/>
		<app-actions
			:resource-uri="$route.name"
			:value-disabled="valuesDisabled"
			@run-action="runAction"
		/>
		<backButtonRoute/>
		<modules-list
			:current-page="params.page"
			:last-page="table.lastPage"
			:rows="rows"
			@click-icon="clickIcon"
			@on-page="onPage"
			@on-search="onSearch"
		>
		</modules-list>
		<section class="modal-filter-footer">
			<modal-sidebar-button
			hidden
			success-color="primary"
			success-text="Atras"
			@accept-button-clicked="returnModule"
			></modal-sidebar-button>
		</section>
		<!--<action-bar
			class="action-mobile"
			:resource-uri="$route.name"
			@run-action="runAction"
		/>!-->
		<action-sidebar
			:title="action.title"
			:value="action.visible"
			:width="action.width"
			@close-modal="closeModal"
		>
			<modules-form
				v-if="isModuleForm"
				:subsidiary-id="subsidiaryId"
				:customer-id="customerId"
				:id="selectedRow.id"
				@close-modal="closeModal"
			/>
			<modules-form-remove
				v-if="isModuleRemove"
				:id="selectedRow.id"
				:name="selectedRow.name"
				@close-modal="closeModal"
			/>
			<v-layout wrap ma-2 v-if="isModuleImport">
				<v-flex xs12 mt-3>
					<label ref="label" for="download-excel">
						<vue-six-four
							ref="vueSixFour"
							id="download-excel"
							hidden
							@vue-six-four="getFile"
						/>
						<v-layout>
							<v-flex xs12 mr-2 class="text-right" >
								<v-btn
									color="success"
									class="btnLoadExcel white--text"
									@click="downloadRules"
								>
									Descargar Plantilla
								<v-icon right dark>file_download</v-icon>
								</v-btn>
							</v-flex>
						</v-layout>
						<v-layout>
							<v-flex xs12 class="container-import">
								<BaseInput
									:height="35"
									label="Adjuntar excel"
									v-model="excelName"
									required
									class="pr-4"
								>
									<span slot="error" class="caption error--text" v-if="!$v.model.base64.required">
										Es necesario importar un archivo excel
									</span>
								</BaseInput>
								<button class="btn-import" @click="showDialog">
									<img src="/static/img/actions-list/excel.svg" alt="importar excel">
								</button>
							</v-flex>
						</v-layout>
					</label>
					</v-flex>
					<section class="modal-filter-footer">
					<modal-sidebar-button
						success-text="Aceptar"
						@cancel-button-clicked="closeModal"
						@accept-button-clicked="sendAccount"
						:is-loading="$v.$invalid || disabledbutton"
					>
					</modal-sidebar-button>
				</section>
			</v-layout>
		</action-sidebar>
	</section>
</template>

<script>

import { mapGetters } from 'vuex';
import { ACCOUNTING_MODULES_FORM, ACCOUNTING_MODULES_REMOVE } from '@/shared/action-codes';
import actionBar from '@/components/shared/action-bar/action-bar';
import actionSidebar from '@/components/shared/action-sidebar';
import backButtonRoute from '@/components/shared/back-button-route';
import modulesList from '@/components/modules/modules-list';
import { required } from 'vuelidate/lib/validators';
import modulesForm from '@/components/modules/modules-form';
import modulesFormRemove from '@/components/modules/modules-form-remove';
import appActions from '@/components/shared/app-actions/app-actions';
import VueSixFour from 'vue-six-four';

function data() {
	return {
		action: {
			code: '',
			title: '',
			visible: false,
			width: 400,
		},
		rows: [],
		disabledbutton: false,
		model: {
			base64: {
				required,
			},
		},
		excelName: null,
		selectedRow: {
			id: null,
			customerId: null,
			subsidiaryId: null,
		},
	};
}

async function loadData() {
	this.$set(this.params, 'customerId', this.customerId);
	this.$set(this.params, 'subsidiaryId', this.currentSubsidiary.id);
	const { records } = await this.loadData('type-register');
	this.rows = records.map(({ id, code, name }) => ({ code, name, id }));
	return this.rows;
}

function clickIcon({ action, row }) {
	this.selectedRow.customerId = row.customerId;
	this.selectedRow.subsidiaryId = row.subsidiaryId;
	this.selectedRow.id = row.id;
	this.selectedRow.name = row.name;
	if (action === 'edit') {
		this.action.title = `Editar - ${row.name}`;
		this.action.code = ACCOUNTING_MODULES_FORM;
		this.action.visible = true;
	} else if (action === 'delete') {
		this.action.code = ACCOUNTING_MODULES_REMOVE;
		this.action.title = `Eliminar - ${row.name}`;
		this.action.visible = true;
	} else if (action === 'dictionary') {
		this.goTo('accounting-dictionary', {
			query: {
				customerId: this.customerId,
				id: this.selectedRow.id,
				name: this.selectedRow.name,
				subsidiaryId: this.currentSubsidiary.id,
			},
		});
	}
}
async function sendAccount() {
	const method = 'post';
	const url = 'dictionary-upload';
	const action = 'creó';
	const newModel = { ...this.model };
	newModel.subsidiaryId = Number(this.subsidiaryId);
	try {
		this.disabledbutton = true;
		await this.$http[method](url, newModel);
		this.disabledbutton = false;
		this.showNotification(`Se ${action} correctamente`);
		this.loadData();
		this.closeModal();
	} catch (error) {
		if (error.status === 500) {
			this.showGenericError();
		} else if (error.status === 400) {
			if (error.data.message === 'RULES_REPEAT') {
				this.showGenericError('No se puede registrar reglas repetidas.');
			} else if (error.data.message === 'FILE_XLSX_ITEM_EMPTY') {
				this.showGenericError('Un item del archivo se encuentra vacío.');
			}
		}
	}
}

function closeModal(reloadList) {
	this.action.code = '';
	this.action.title = '';
	this.action.visible = false;
	this.selectedRow.id = 0;
	if (reloadList) {
		loadData.call(this);
	}
}

function getFile(fileInfo) {
	this.excelName = fileInfo.name.replace(/\s/g, '-');
	const base64data = fileInfo.sixFour.split('base64,');
	this.model.base64 = base64data[1];
}

function showDialog() {
	this.$refs.label.click();
}

async function downloadRules() {
	const body = {
		customerId: this.customerId,
		subsidiaryId: this.subsidiaryId,
	};
	const response = await this.$http.post('download-dictionary-excel', body);
	const byteCharacters = atob(response.data.base64);
	const byteNumbers = [];
	byteCharacters.split('').forEach((char) => {
		byteNumbers.push(char.charCodeAt(0));
	});

	const byteArray = new Uint8Array(byteNumbers);
	const buffer = byteArray.buffer;

	// Crear un Blob a partir del ArrayBuffer
	const blob = new Blob([buffer], { type: 'application/octet-stream' });

	// Crear un objeto URL para descargar el archivo
	const url = URL.createObjectURL(blob);

	// Crear un enlace (link) para la descarga
	const link = document.createElement('a');
	link.href = url;
	link.download = 'diccionario_de_datos.xlsx'; // Cambia el nombre del archivo según desees

	// Simular un clic para iniciar la descarga
	link.click();

	// Revocar el objeto URL para liberar recursos del navegador
	URL.revokeObjectURL(url);
}


async function created() {
	await loadData.call(this);
}

function customerId() {
	return Number(this.$route.query.customerId);
}

function isModuleForm() {
	return this.action.code === ACCOUNTING_MODULES_FORM;
}

function isModuleRemove() {
	return this.action.code === ACCOUNTING_MODULES_REMOVE;
}
function isModuleImport() {
	return this.action.code === 'import-data-dictionary';
}

function validations() {
	const validation = {
		model: {
			base64: {
				required,
			},
		},
	};
	return validation;
}

async function onPage(page) {
	this.params.page = page;
	await loadData.call(this);
}

async function onSearch(value) {
	this.params.page = 1;
	this.$set(this.params, 'search', value || null);
	await loadData.call(this);
}

function runAction({ name, code }) {
	if (code === 'import-data-dictionary') {
		this.action.title = name;
		this.action.code = code;
		this.action.visible = true;
		this.action.width = 400;
	} else {
		this.action.title = name;
		this.action.code = code;
		this.action.visible = true;
		this.selectedRow.id = 0;
	}
}

function valuesDisabled() {
	const userI = typeof this.$userInfo === 'string' ? JSON.parse(this.$userInfo) : this.$userInfo;
	const notFranchise = userI && (userI.company.franchise === null || userI.company.franchise === 0);
	const fatherFranchise = userI && userI.company
		&& userI.company.franchise
		&& userI.subsidiary.father
		? userI.company.franchise === 1 && userI.subsidiary.father === 1 : false;
	return [
		{ code: 'new-accounting-module', disabled: (!notFranchise && !fatherFranchise) },
		{ code: 'import-data-dictionary', disabled: (!notFranchise && !fatherFranchise) },
	];
}

function subsidiaryId() {
	return Number(this.$route.query.subsidiaryId);
}


function title() {
	return `${this.$route.query.name} / ${this.$route.meta.title}`;
}

function returnModule() {
	this.$router.go(-1);
}

function currentSubsidiary(newSub) {
	const { id, name, customerId: idCustomer } = newSub;
	this.goTo(
		'accounting-modules',
		{
			query: {
				subsidiaryId: id,
				name: name.split(' ').join('-'),
				customerId: idCustomer,
			},
		},
	);
}

function routeHandler() {
	loadData.call(this);
}

export default {
	name: 'page-modules',
	created,
	components: {
		actionBar,
		appActions,
		VueSixFour,
		actionSidebar,
		modulesForm,
		modulesList,
		modulesFormRemove,
		backButtonRoute,
		BaseInput: () => import('@/components/shared/inputs/base-input'),
	},
	computed: {
		...mapGetters('subsidiary', [
			'currentSubsidiary',
		]),
		customerId,
		isModuleForm,
		isModuleImport,
		isModuleRemove,
		subsidiaryId,
		title,
		valuesDisabled,
	},
	data,
	methods: {
		clickIcon,
		closeModal,
		downloadRules,
		onPage,
		getFile,
		sendAccount,
		showDialog,
		onSearch,
		returnModule,
		routeHandler,
		runAction,
	},
	validations,
	watch: {
		'$route.params': routeHandler,
		currentSubsidiary,
	},
};
</script>
<style lang="scss" scoped>
.text-right {
  text-align: center;
}
.container-import {
	position: relative;

	.btn-import {
		background: #03A89E;
		border-radius: 0 5px 5px 0;
		height: 35px;
		padding: 5px 7px 5px 0;
		position: absolute;
		right: 0;
		top: 16px;
		width: 51px;
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/modules/page-modules.vue